/**
 * Get entity info from data object (version 1)
 */
export function getEntityInfo(data: any) {
  const source = data.entity ? { entity: data.entity, roleId: data.entity.id } : null;

  if (!source) return null;

  return {
    classificationValue: source.entity?.entity?.classification?.value ?? null,
    entityName: source.entity?.entity?.name ?? null,
    roleId: source.roleId,
  };
}

/**
 * Get entity info from data object (version 2)
 */
export function getEntityInfo2(data: any) {
  const source = data.debtor ?? data.creditor ?? data.credebtor;

  if (!source) return null;

  return {
    classificationValue: source.entity?.classification?.value ?? null,
    entityName: source.entity?.name ?? null,
    parentRoleId: source.parentRoleId ?? null,
  };
}

/**
 * Detect property from data array and join with comma
 */
export function detectProperty(data: any[], propertyId: string, propertyTitle?: string): string {
  const result = data
    .filter((item) => item.propertyId === propertyId && (!propertyTitle || item.propertyTitle === propertyTitle))
    .map((item) => item.propertyValue)
    .join(', ');

  return result || '';
}

import { parsePhoneNumbersModify } from './phone-utils';

/**
 * Detect property from data array and format with new lines and phone number parsing
 */
export function detectPropertyNewLineHelper(data: any[], propertyId: string, propertyTitle?: string): string {
  const result = data
    .filter((item) => item.propertyId === propertyId && (!propertyTitle || item.propertyTitle === propertyTitle))
    .map((item) => (item.propertyValue ? `<p>${item.propertyValue}</p>` : ''))
    .join('\n');
  return result || '';
}
